function store(key, value) {
  
    if (key === "user") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }
  
  function get(key) {
    let data = localStorage.getItem(key);
    if (!data) return "";
    try {
      data = JSON.parse(data);
    } catch (e) {
      // eslint-disable-next-line no-self-assign
      data = data;
    }
    return data;
  }
  
  function remove(key) {
    localStorage.removeItem(key);
  }
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default {
    store,
    get,
    remove,
  };
  